import React from "react";

const ReportingIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0118 9.2H9.46182V8H20.0118C21.8232 8 23.3018 9.47863 23.3018 11.29V22.11H22.1018V11.29C22.1018 10.1414 21.1604 9.2 20.0118 9.2Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97814 8.73157C8.24862 8.36847 8.72364 8 9.46182 8C10.4632 8 11.2718 8.80863 11.2718 9.81V21.44C11.2718 22.0453 11.5333 22.5931 11.9487 22.9759C11.9513 22.9723 11.9512 22.9722 11.9512 22.9722L11.9502 22.9715C11.9527 22.9732 11.9576 22.9764 11.966 22.9818C11.983 22.9926 12.0109 23.0098 12.0481 23.0301C12.1235 23.0715 12.2311 23.1231 12.3578 23.1637C12.617 23.247 12.8983 23.2681 13.1583 23.141L13.1703 23.1351C13.3082 23.0715 13.4463 22.9559 13.655 22.7221L14.346 21.7835L14.3932 21.7416L14.7918 22.19C14.3932 21.7416 14.3931 21.7416 14.3932 21.7416L14.3946 21.7403L14.3962 21.7389L14.3999 21.7356L14.4093 21.7276C14.4164 21.7216 14.4254 21.7143 14.4359 21.706C14.4564 21.6899 14.486 21.6678 14.5221 21.6446L14.5231 21.644C14.5661 21.6165 14.7324 21.51 14.9518 21.51H25.1218L25.2818 21.63L24.9218 22.11C25.2818 21.63 25.2817 21.6299 25.2818 21.63L25.284 21.6316L25.2863 21.6334L25.2912 21.6372L25.3025 21.6462C25.3106 21.6528 25.3204 21.6611 25.3314 21.671C25.3507 21.6886 25.3847 21.7214 25.4193 21.7675C25.4479 21.8056 25.5152 21.9024 25.539 22.0451C25.5655 22.2041 25.5301 22.3831 25.4155 22.5287L24.731 23.4612L24.7262 23.4673C24.4375 23.8403 24.198 24.0509 23.7556 24.3074C23.1608 24.6607 22.5727 24.73 22.1118 24.73H13.3618C11.5504 24.73 10.0718 23.2514 10.0718 21.44V9.81C10.0718 9.47137 9.80044 9.2 9.46182 9.2C9.17999 9.2 9.03501 9.32153 8.94049 9.44843C8.88814 9.5187 8.85216 9.59204 8.82961 9.64873C8.81864 9.67628 8.81173 9.69767 8.80814 9.70968L8.80573 9.71817L8.16363 12.2666L7 11.9734L7.63898 9.43745L7.63921 9.43646L7.64373 9.41846C7.64732 9.40458 7.65215 9.38695 7.65838 9.3661C7.67081 9.32452 7.68905 9.26935 7.71465 9.20502C7.76522 9.07796 7.84799 8.9063 7.97814 8.73157ZM23.7938 22.71H15.154L14.589 23.4774L14.5712 23.4975C14.5617 23.5084 14.552 23.5192 14.5423 23.53H22.1118C22.4501 23.53 22.8007 23.4795 23.1447 23.2745L23.1512 23.2707C23.4642 23.0895 23.5849 22.9805 23.7728 22.7386L23.7938 22.71ZM11.9502 22.9715L11.9492 22.9708L11.9481 22.97C11.9481 22.97 11.9492 22.9709 11.9502 22.9715Z"
      />
      <path
        d="M13.342 17.16H14.472C14.762 17.16 14.992 17.39 14.992 17.68V19.33H12.812V17.68C12.812 17.39 13.042 17.16 13.332 17.16H13.342Z"
        fill="#1A8B5A"
      />
      <path
        d="M16.1218 14.6H17.2518C17.5418 14.6 17.7718 14.83 17.7718 15.12V19.34H15.5918V15.12C15.5918 14.83 15.8218 14.6 16.1118 14.6H16.1218Z"
        fill="#1A8B5A"
      />
      <path
        d="M18.9118 13.39H20.0418C20.3318 13.39 20.5618 13.62 20.5618 13.91V19.33H18.3818V13.91C18.3818 13.62 18.6118 13.39 18.9018 13.39H18.9118Z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default ReportingIcon;
